import Mutations from '../../odata/mutations';

export default {
  ...new Mutations('xeroRepeatingInvoice'),
  ...new Mutations('xeroRepeatingInvoices'),
};
